/* src/components/Error.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import Exclamation from "./Icon/Exclamation.svelte.js";
import Localized from "./Lang/Localized.svelte.js";

function create_fragment(ctx) {
	let div2;
	let div0;
	let exclamation;
	let t0;
	let div1;
	let h1;
	let localized;
	let t1;
	let h3;
	let t2;
	let current;
	exclamation = new Exclamation({});
	localized = new Localized({ props: { key: "CONNECTION_ERROR" } });

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			create_component(exclamation.$$.fragment);
			t0 = space();
			div1 = element("div");
			h1 = element("h1");
			create_component(localized.$$.fragment);
			t1 = space();
			h3 = element("h3");
			t2 = text(/*message*/ ctx[0]);
			this.h();
		},
		l(nodes) {
			div2 = claim_element(nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div0 = claim_element(div2_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			claim_component(exclamation.$$.fragment, div0_nodes);
			div0_nodes.forEach(detach);
			t0 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			h1 = claim_element(div1_nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			claim_component(localized.$$.fragment, h1_nodes);
			h1_nodes.forEach(detach);
			t1 = claim_space(div1_nodes);
			h3 = claim_element(div1_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t2 = claim_text(h3_nodes, /*message*/ ctx[0]);
			h3_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "h-12 w-12 flex-none text-yellow-500 dark:text-yellow-200");
			attr(h1, "class", "font-medium text-gray-700 dark:text-gray-100");
			attr(h3, "class", "text-xs text-gray-500 dark:text-gray-300");
			attr(div1, "class", "px-3");
			attr(div2, "class", "shadow pt-2 pb-1 px-3 rounded-t-none rounded-b-md flex flex-row border-t-2 bg-white border-yellow-500 dark:bg-gray-700 dark:border-yellow-200");
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			mount_component(exclamation, div0, null);
			append(div2, t0);
			append(div2, div1);
			append(div1, h1);
			mount_component(localized, h1, null);
			append(div1, t1);
			append(div1, h3);
			append(h3, t2);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*message*/ 1) set_data(t2, /*message*/ ctx[0]);
		},
		i(local) {
			if (current) return;
			transition_in(exclamation.$$.fragment, local);
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(exclamation.$$.fragment, local);
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div2);
			destroy_component(exclamation);
			destroy_component(localized);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { message } = $$props;

	$$self.$$set = $$props => {
		if ("message" in $$props) $$invalidate(0, message = $$props.message);
	};

	return [message];
}

class Error extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { message: 0 });
	}
}

export default Error;
//# sourceMappingURL=Error.svelte.js.map
